import { useState, useEffect, useMemo } from 'react'
import { CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import MyTable from '../MyTable/MyTable'
import SortItems from '../MyTable/SortItems'
import { string, func, arrayOf, shape, bool } from 'prop-types'

const styles = makeStyles((theme) => ({
  centerDiv: {
    margin: 'auto',
    padding: '10px',
    textAlign: 'center',
  },
  spinner: {
    color: theme.palette.primary.main,
  },
}))

const WorkerLookupItems = (props) => {
  const classes = styles(props)
  const {
    callbackFromParentFlatSelections,
    callbackFromParentCountryCodeSelections,
    headerName,
    dataFromParent,
    fetchingState,
  } = props

  const [value, setValue] = useState({})

  useEffect(() => setValue(value), [value])

  function selectionDataCallback(selections) {
    let newSelected = Object.assign({}, value)
    let countryCodeSelected = Object.assign({}, value)

    Object.entries(newSelected).map(([key]) => (newSelected[key] = false))
    Object.entries(countryCodeSelected).map(
      ([key]) => (countryCodeSelected[key] = false),
    )

    selections.forEach(function (value, key) {
      if ('location_id' in value.original) {
        newSelected[value.original['location_id']] = true
        countryCodeSelected[value.original['country_code']] = true
      }
    })

    setValue(newSelected)
    setValue(countryCodeSelected)
    callbackFromParentFlatSelections(newSelected)
    callbackFromParentCountryCodeSelections(countryCodeSelected)
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Location',
        columns: [
          {
            Header: headerName,
            accessor: 'location_id',
            sortType: (prev, curr, columnId) => {
              return SortItems(prev, curr, columnId)
            },
          },
          {
            Header: 'Region',
            accessor: 'region',
            sortType: (prev, curr, columnId) => {
              return SortItems(prev, curr, columnId)
            },
          },
          {
            Header: 'Group',
            accessor: 'group',
            sortType: (prev, curr, columnId) => {
              return SortItems(prev, curr, columnId)
            },
          },
          {
            Header: 'District',
            accessor: 'district',
            sortType: (prev, curr, columnId) => {
              return SortItems(prev, curr, columnId)
            },
          },
          {
            Header: 'Loc Type',
            accessor: 'location_type',
            sortType: (prev, curr, columnId) => {
              return SortItems(prev, curr, columnId)
            },
          },
          {
            Header: 'State',
            accessor: 'work_state',
            sortType: (prev, curr, columnId) => {
              return SortItems(prev, curr, columnId)
            },
          },
          {
            Header: 'Country Code',
            accessor: 'country_code',
            sortType: (prev, curr, columnId) => {
              return SortItems(prev, curr, columnId)
            },
          },
        ],
      },
    ],
    [], // eslint-disable-line react-hooks/exhaustive-deps
  )

  const tempData = dataFromParent || []

  if (fetchingState) {
    return (
      <div className={classes.centerDiv}>
        <CircularProgress className={classes.spinner} thickness={7} />
        <h3>loading...</h3>
      </div>
    )
  } else {
    return (
      <MyTable
        columns={columns}
        data={tempData}
        defaultPageSize={10} // You can set this to any default
        defaultPageIndex={0}
        maxPageCount={Math.ceil(tempData.length / 10)} // calculate based on data
        onPageSizeChange={(pageSize, pageIndex) => {
          console.log('Page size changed:', pageSize, 'Page index:', pageIndex)
        }}
        onPageChange={(pageIndex) => {
          console.log('Page changed to:', pageIndex)
        }}
        onFlatRowSelectChange={(rowsSelected) => {
          selectionDataCallback(rowsSelected)
        }}
        defaultSelectedRows={{}}
        useCheckboxSelection={true}
      />
    )
  }
}

export default WorkerLookupItems

WorkerLookupItems.propTypes = {
  headerName: string,
  dataFromParent: arrayOf(
    shape({
      location_id: string,
      region: string,
      group: string,
      district: string,
      location_type: string,
      work_state: string,
      country_code: string,
    }),
  ),
  fetchingState: bool,
  callbackFromParentSelections: func.isRequired,
  callbackFromParentFlatSelections: func.isRequired,
  callbackFromParentCountryCodeSelections: func.isRequired,
}
